module.exports = __webpack_public_path__ + "img/rules.81e63005.png";